import { Button, Form, Modal, Table } from 'react-bootstrap'
import { ProtocolVersion } from 'entities/protocol_version'
import { TableBody, TableCell } from 'components/shared/widget'

type ProtocolVersionProbesModalProps = {
    onClose: () => void
    show: boolean
    protocolVersion?: ProtocolVersion
}

export const ProtocolVersionProbesModal = (props: ProtocolVersionProbesModalProps): JSX.Element => {
    return (
        <>
            <Modal show={props.show} onHide={props.onClose} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Probes</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Table>
                        <thead>
                            <tr>
                                <TableCell th minWidth={100}>
                                    Probe
                                </TableCell>
                                {!props.protocolVersion?.productItemId && (
                                    <TableCell th width={150}>
                                        QC type
                                    </TableCell>
                                )}
                                <TableCell th width={100} align="center">Range</TableCell>
                                {(!props.protocolVersion?.productItem || props.protocolVersion?.productItem?.isStandardQc || props.protocolVersion?.productItem?.isRnaStandardQc) && <>
                                    <TableCell th width={100} align="center">LCL</TableCell>
                                    <TableCell th width={100} align="center">UCL</TableCell>
                                    <TableCell th width={100} align="center">R-UCL</TableCell>
                                </>}
                                {
                                    !(!props.protocolVersion?.productItem || props.protocolVersion?.productItem?.isStandardQc || props.protocolVersion?.productItem?.isRnaStandardQc) &&
                                    <>
                                        <TableCell th width={200} align="center">Ct Range</TableCell>
                                        <TableCell th width={200} align="center">Is Negative Marker</TableCell>
                                    </>
                                }
                            </tr>
                        </thead>
                        <TableBody>
                            {props.protocolVersion?.protocolVersionProbes?.sort((a, b) => ((a.probe?.name ?? '') > (b.probe?.name ?? '') ? 1 : -1)).map((p, index) => {
                                return (
                                    <tr key={'probe-' + index}>
                                        <TableCell>{p.probe?.name}</TableCell>
                                        {!props.protocolVersion?.productItemId && <TableCell>{p.qcType}</TableCell>}
                                        <TableCell align="center">
                                            {p.minRange} ~ {p.maxRange}
                                        </TableCell>
                                        {
                                            (!props.protocolVersion?.productItem || props.protocolVersion?.productItem?.isStandardQc || props.protocolVersion?.productItem?.isRnaStandardQc) &&
                                            <>
                                                <TableCell align="center">{p.xlcl}</TableCell>
                                                <TableCell align="center">{p.xucl}</TableCell>
                                                <TableCell align="center">{p.rucl}</TableCell>
                                            </>
                                        }
                                        {
                                            !(!props.protocolVersion?.productItem || props.protocolVersion?.productItem?.isStandardQc || props.protocolVersion?.productItem?.isRnaStandardQc) &&
                                            <>
                                                <TableCell align="center">
                                                    {p.ctMinRange} ~ {p.ctMaxRange}
                                                </TableCell>
                                                <TableCell align="center"><Form.Check
                                                    type={'checkbox'}
                                                    checked={p.isNegativeMarker}
                                                /></TableCell>
                                            </>
                                        }
                                    </tr>
                                )
                            })}
                        </TableBody>
                    </Table>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={props.onClose}>
                        閉じる
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}
